import "./Portfolio.css";

const portfolio = [
  {
    title: "School Management System",
    image: "/images/project1.jpg",
    category: "Web Application",
  },
  {
    title: "Hospital Management",
    image: "/images/project2.jpg",
    category: "Software",
  },
  {
    title: "E-Commerce Website",
    image: "/images/project3.jpg",
    category: "Website",
  },
  {
    title: "College ERP",
    image: "/images/project4.jpg",
    category: "Management",
  },
  {
    title: "Business Website",
    image: "/images/project5.jpg",
    category: "Corporate",
  },
  {
    title: "Mobile App UI",
    image: "/images/project6.jpg",
    category: "Application",
  },
];

function Portfolio() {
  return (
    <section className="portfolio" id="portfolio">
      <div className="container">

        <div className="section-title">
          <h2>Our Portfolio</h2>
          <p>
            Some of our recent projects developed with modern technologies.
          </p>
        </div>

        <div className="portfolio-grid">

          {portfolio.map((item,index)=>(
            <div className="portfolio-card" key={index}>

              <img src={item.image} alt={item.title}/>

              <div className="overlay">

                <span>{item.category}</span>

                <h3>{item.title}</h3>

                <button>View Project</button>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default Portfolio;